import React, { useState, useEffect, useCallback } from "react";
import { useDebouncedCallback } from "use-debounce";
import { useIntl } from "react-intl";
import { AutoComplete } from "antd";

import {
  post,
  checkResponse,
  checkHttpStatus,
} from "../../../modules/httpFunctions";
import {
  getEntities,
  showMessageIfExists,
} from "../../../modules/crudOperations";
import ClientContainer from "./clientContainer";
import { error } from "../../../modules/messages";
import { handleError } from "../../../modules/errorLogger";
import { parseClient } from "../../../modules/consignmentFunctions";

import "./index.css";

const { Option } = AutoComplete;

function ClientChoice({ onClientChange }) {
  const intl = useIntl();
  const [clients, setClients] = useState();
  const handleLoadClients = useCallback((value) => {
    getEntities("client", setClients, undefined, {
      search: value,
    });
  }, []);

  const handleSearch = useDebouncedCallback((value) => {
    handleLoadClients(value);
  }, 1000);

  const handleSelect = useCallback(
    (value) => {
      if (value.length < 7) {
        const numberValue = parseInt(value);
        const chosenClient =
          clients &&
          clients !== "e" &&
          clients.find((a) => a.id === numberValue);
        chosenClient && onClientChange(chosenClient);
      } else {
        const evoCode = value.split("_")[0];
        post(`client/evo-customer/${evoCode}`, {})
          .then((r) => {
            if (checkHttpStatus(r) && checkResponse(r)) {
              const chosenClient = clients.find((a) => a.evoCode === evoCode);
              chosenClient &&
                onClientChange({ ...chosenClient, id: r.data.id });
            } else {
              showMessageIfExists(r);
            }
          })
          .catch((err) => {
            error(
              intl.formatMessage({
                id: "user.client.loadError",
                defaultMessage: "Při načítání klientů nastala chyba!",
              })
            );
            handleError(err);
          });
      }
    },
    [intl, clients, onClientChange]
  );

  const [dataSource, setDataSource] = useState();
  useEffect(() => {
    if (clients) {
      clients !== "e"
        ? setDataSource(
            clients.map((c, i) => ({
              value: c.id === -1 ? `${c.evoCode}_${i}` : c.id.toString(),
              text: parseClient(c),
            }))
          )
        : error(
            intl.formatMessage({
              id: "user.client.loadError",
              defaultMessage: "Při načítání klientů nastala chyba!",
            })
          );
    }
  }, [intl, clients]);

  return (
    <ClientContainer>
      <AutoComplete
        allowClear
        dataSource={dataSource}
        onSelect={handleSelect}
        onSearch={handleSearch}
        className="client-choice-select"
        placeholder={intl.formatMessage({
          id: "user.client.info",
          defaultMessage: "zadejte z-account nebo název klienta",
        })}
      >
        {dataSource &&
          dataSource.map((d, i) => (
            <Option key={i} title={d.text} value={d.value}>
              {d.text}
            </Option>
          ))}
      </AutoComplete>
    </ClientContainer>
  );
}

export default ClientChoice;
